import { ChevronDown, Download, Upload } from "lucide-react";
import { Button } from "@/components/ui/Button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/DropdownMenu";

interface Props {
  canExport: boolean;
  canImport: boolean;
  exportHref: string;
  onOpenImport: () => void;
}

export default function ActionsMenu({ canExport, canImport, exportHref, onOpenImport }: Props) {
  if (!canExport && !canImport) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          Actions
          <ChevronDown className="ml-1.5 h-3.5 w-3.5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[14rem]">
        {canImport && (
          <DropdownMenuItem onSelect={onOpenImport}>
            <Upload className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
            Import spreadsheet…
          </DropdownMenuItem>
        )}
        {canExport && (
          <DropdownMenuItem asChild>
            <a href={exportHref}>
              <Download className="mr-2 h-3.5 w-3.5 text-muted-foreground" />
              Export CSV
            </a>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
